import pluralize from "pluralize";
import {PropsWithChildren, useContext} from "react";

import {ButtonWithMutationAndConfirmationDialog} from "@/components/ButtonWithMutationAndConfirmationDialog/ButtonWithMutationAndConfirmationDialog.tsx";
import {
  GQL_STATUS_PAGE_QUERY,
  GQL_SUBSCRIBERS,
  GQL_SUBSCRIBERS_COUNTS,
  GQL_UNSUBSCRIBE_TARGET,
} from "@/lib/queries/statuspages.ts";
import {StatusPageContext} from "@/pages/statuspages/statuspages-manage/ManageStatusPageTabContainer.utils.tsx";

export interface StatusPageSubscribersDeleteActionButtonProps extends PropsWithChildren {
  subscriberIds: number[];
  isBulkAction?: boolean;
  onSuccess: () => void;
  variant?: "tableRow" | "tableCrown";
}

export const StatusPageSubscribersDeleteActionButton = ({
  subscriberIds,
  isBulkAction,
  children,
  onSuccess,
  variant,
}: StatusPageSubscribersDeleteActionButtonProps) => {
  const {statusPage} = useContext(StatusPageContext);
  return (
    <ButtonWithMutationAndConfirmationDialog
      dialogTitle={`Delete ${pluralize("Subscriber", subscriberIds.length)}`}
      dialogElement={
        <p>
          Are you sure you want to delete the {isBulkAction ? "selected" : ""}{" "}
          {pluralize("Subscriber", subscriberIds.length)}?
        </p>
      }
      mutation_hook_options={{
        refetchQueries: [GQL_STATUS_PAGE_QUERY, GQL_SUBSCRIBERS_COUNTS, GQL_SUBSCRIBERS],
      }}
      mutation_GQL={GQL_UNSUBSCRIBE_TARGET}
      mutation_variables={{statusPageID: statusPage.id, targets: subscriberIds}}
      postMutationAction={() => onSuccess()}
      variant={variant}
      tooltip={false}
    >
      {children}
    </ButtonWithMutationAndConfirmationDialog>
  );
};
